import React, { useState, useEffect } from "react";
import { ref, onValue, push, set, serverTimestamp, update } from "firebase/database";
import { db } from "../firebase";
import { FaUsers, FaPlus, FaCompass, FaTimes, FaCheck } from "react-icons/fa";

function CommunitiesList({ currentUser }) {
  const [communities, setCommunities] = useState([]);
  const [showCreate, setShowCreate] = useState(false);
  const [newName, setNewName] = useState("");
  const [newDesc, setNewDesc] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const communityRef = ref(db, "communities");
    const unsubscribe = onValue(communityRef, (snapshot) => {
      const data = snapshot.val();
      if (!data) {
        setCommunities([]);
        return;
      }
      const commList = Object.entries(data).map(([id, value]) => ({
        id,
        ...value
      }));
      setCommunities(commList);
    });
    return () => unsubscribe();
  }, []);

  const handleCreate = async (e) => {
    e.preventDefault();
    if (!newName.trim() || !currentUser) return;
    setLoading(true);

    try {
      const newCommRef = push(ref(db, "communities"));
      await set(newCommRef, {
        name: newName,
        description: newDesc,
        createdBy: currentUser.uid,
        createdAt: serverTimestamp(),
        members: {
          [currentUser.uid]: true
        }
      });
      setNewName("");
      setNewDesc("");
      setShowCreate(false);
    } catch (err) {
      console.error("Create error:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleJoin = async (commId) => {
    if (!currentUser) return;
    try {
      await update(ref(db, `communities/${commId}/members`), {
        [currentUser.uid]: true
      });
    } catch (err) {
      console.error("Join error:", err);
    }
  };

  const defaultCommunities = [
    { id: "c1", name: "Bharat Tech Innovators", description: "Official hub for Indian developers & tech leaders", members: {} },
    { id: "c2", name: "Sampark AI Explorers", description: "Discussing AI models, neural APIs & prompts", members: {} },
    { id: "c3", name: "Open Source India", description: "Building community-first open software for India", members: {} }
  ];

  const displayCommunities = communities.length > 0 ? communities : defaultCommunities;

  return (
    <div className="sidebar-view communities-view">
      <div className="sidebar-header">
        <h2>Communities</h2>
        <div className="sidebar-header-actions">
          <FaPlus title="New Community" onClick={() => setShowCreate(true)} style={{ cursor: 'pointer' }} />
        </div>
      </div>

      <div className="chat-list">
        {/* COMING SOON BANNER */}
        <div style={{ margin: '12px 14px 6px 14px', padding: '12px 14px', background: 'rgba(124, 58, 237, 0.1)', border: '1px solid rgba(124, 58, 237, 0.25)', borderRadius: '14px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <FaCompass style={{ fontSize: '18px', color: '#7c3aed' }} />
            <div>
              <div style={{ fontWeight: '700', fontSize: '13px', color: 'var(--text-primary)' }}>Public Communities & Channels</div>
              <div style={{ fontSize: '11px', color: 'var(--text-secondary)' }}>Broadcast channels for creators</div>
            </div>
          </div>
          <span style={{ background: '#7c3aed', color: 'white', fontSize: '10px', fontWeight: '800', padding: '3px 8px', borderRadius: '100px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Coming Soon</span>
        </div>

        <div className="chat-item" onClick={() => setShowCreate(true)} style={{ cursor: 'pointer' }}>
          <div className="avatar" style={{ background: '#00a884', color: 'white' }}>
            <FaPlus />
          </div>
          <div className="chat-item-content">
            <div className="chat-info">
              <div className="chat-top">
                <h4>New Community</h4>
              </div>
              <p className="preview">Create your own space for groups</p>
            </div>
          </div>
        </div>

        <div className="section-divider" style={{ padding: '20px 15px', fontSize: '12px', color: '#00a884', fontWeight: '700', letterSpacing: '1px' }}>
          AVAILABLE COMMUNITIES
        </div>

        {displayCommunities.map((comm) => {
          const isMember = comm.members && comm.members[currentUser?.uid];
          return (
            <div className="chat-item community-list-item" key={comm.id}>
              <div className="avatar" style={{ background: 'var(--hover-bg)', color: '#00a884', border: '1px solid rgba(0, 168, 132, 0.2)' }}>
                <FaUsers />
              </div>
              <div className="chat-item-content">
                <div className="chat-info">
                  <div className="chat-top">
                    <h4>{comm.name}</h4>
                    {isMember ? (
                      <span className="member-badge"><FaCheck /> Joined</span>
                    ) : (
                      <button className="join-btn" onClick={() => handleJoin(comm.id)}>Join</button>
                    )}
                  </div>
                  <p className="preview">{comm.description || "Bharat Connect Community"}</p>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {showCreate && (
        <div className="community-modal-overlay">
          <div className="community-modal">
            <div className="modal-header">
              <h3>Create Community</h3>
              <FaTimes onClick={() => setShowCreate(false)} className="close-btn" />
            </div>
            <form onSubmit={handleCreate}>
              <div className="input-group">
                <label>Community Name</label>
                <input 
                  type="text" 
                  value={newName} 
                  onChange={(e) => setNewName(e.target.value)} 
                  placeholder="e.g. Frontend Architects"
                  required
                />
              </div>
              <div className="input-group">
                <label>About</label>
                <textarea 
                  value={newDesc} 
                  onChange={(e) => setNewDesc(e.target.value)} 
                  placeholder="What is this community about?"
                />
              </div>
              <button type="submit" className="create-submit-btn" disabled={loading}>
                {loading ? "Creating..." : "Create Community"}
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default CommunitiesList;
